import { isEmptyObject } from 'src/app/infrastructure/functions/is-empty-object.function';
import { ILevelGeneralListData, levelGeneralListData } from 'src/app/infrastructure/models/level-general-list-data';
import { IPageListDto, pageListDto } from 'src/assets/common/models/page-list-dto.g';

export const pageListData = {
    ...levelGeneralListData,
    guid: 'guid',
    nr: 'nr',
    name: 'name',
    displayName: 'displayName',
    isTab: 'isTab',
    deleted: 'deleted',    
    inactive: 'inactive',
} as const;

export type TPageListData = (typeof pageListData)[keyof typeof pageListData];

export interface IPageListData extends ILevelGeneralListData {
    [pageListData.guid]: string;
    [pageListData.nr]: number | null;
    [pageListData.name]: string | null;
    [pageListData.displayName]: string | null;
    [pageListData.isTab]: boolean;
    [pageListData.deleted]: boolean;
    [pageListData.inactive]: boolean;
}

export class PageListData
    implements IPageListData, ILevelGeneralListData
{
    [pageListData.guid]!: string;
    [pageListData.nr]: number | null = null;
    [pageListData.name]: string | null = null;
    [pageListData.displayName]: string | null = null;
    [pageListData.isTab]: boolean = false;
    [pageListData.deleted]!: boolean;
    [pageListData.inactive]!: boolean;

    private constructor(
        modelListDto?: IPageListDto | null
    ) {
        if (!modelListDto || isEmptyObject(modelListDto)) return;

        this[pageListData.guid] = modelListDto[pageListDto.guid]!;
        this[pageListData.nr] = modelListDto[pageListDto.nr];
        this[pageListData.name] = modelListDto[pageListDto.name];
        this[pageListData.displayName] = modelListDto[pageListDto.displayName];
        this[pageListData.isTab] = modelListDto[pageListDto.isTab] ?? false;
        this[pageListData.deleted] = modelListDto[pageListDto.deleted]!;
        this[pageListData.inactive] = modelListDto[pageListDto.inactive]!;
    }

    static create(modelListDto?: IPageListDto | null): IPageListData | null {
        return modelListDto ? new PageListData(modelListDto) : null;
    }
}
